import { Model } from '../../shared-features/models/model';
import { Expose } from 'class-transformer';

export class ProductTypeInput extends Model {

  @Expose() isDefault?: boolean= false;
  @Expose() productTypeId: number;


  constructor() {
    super();
  }
}
